module.exports = __webpack_public_path__ + "img/img-equipment2.5acb42f6.png";